<div class="h-full bg-neutral-10 scrollbar flex flex-col justify-between p-4">
  <div class="grow flex flex-col justify-center gap-4">
    <h6 class="text-center">{{ 'outlook.auth.title' | translate }}</h6>
    <p class="text-body text-pretty">
      {{ 'outlook.auth.description' | translate }}
    </p>
    <div class="py-2 flex flex-col items-center gap-2">
      <button
        kendoButton
        id="outlook-auth-ui-login-loginCloud"
        class="min-w-[200px]"
        themeColor="primary"
        (click)="openDialog(LoginType.Cloud)"
      >
        {{ 'outlook.buttons.loginCloud' | translate }}
      </button>
      <button
        kendoButton
        themeColor="secondary"
        id="outlook-auth-ui-login-loginOnPrem"
        class="min-w-[200px] transparent"
        (click)="openDialog(LoginType.OnPrem)"
      >
        {{ 'outlook.buttons.loginOnPrem' | translate }}
      </button>
      <button
        kendoButton
        id="outlook-auth-ui-login-signup"
        (click)="openLink('signup')"
        class="min-w-[200px]"
        themeColor="tertiary"
      >
        {{ 'outlook.buttons.signUp' | translate }}
      </button>
    </div>
    <p class="text-body">{{ 'outlook.auth.subtitle' | translate }}</p>
    <div class="flex justify-center items-center gap-2">
      <button
        id="outlook-auth-ui-login-policy"
        (click)="openLink('policy')"
        class="text-link bg-transparent"
      >
        {{ 'outlook.auth.policy' | translate }}
      </button>
      <span>|</span>
      <button
        id="outlook-auth-ui-login-terms"
        (click)="openLink('terms')"
        class="text-link bg-transparent"
      >
        {{ 'outlook.auth.terms' | translate }}
      </button>
    </div>
    <p class="caption text-center">
      {{ 'outlook.menu.appVersion' | translate }} {{ appVersion }}
    </p>
  </div>
</div>

<maximizer-outlook-notification
  #notification
  [closable]="true"
  [appendTo]="viewContainerRef"
>
</maximizer-outlook-notification>
